import { LoadableLazy } from '@confluence/loadable';

export const DisableApprovalsModal = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-DisableApprovalsModal" */ '../src/Modals/DisableApprovalsModal.tsx'
			)
		).DisableApprovalsModal,
});
